import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";
import { scrollToId } from "@/lib/scroll";

export default function WhoWeAre() {
    return (
        <section
            id="who-we-are"
            data-testid="who-we-are-section"
            className="bg-[#FAFAF9] py-24 lg:py-32"
        >
            <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:gap-20 lg:px-12">
                <div className="lg:col-span-6">
                    <Reveal>
                        <Eyebrow dark>Who We Are</Eyebrow>
                        <h2 className="mt-6 font-display text-3xl font-extrabold leading-[1.1] tracking-tight text-[#0F172A] sm:text-4xl lg:text-5xl">
                            An operating platform with an{" "}
                            <span className="font-serif font-medium italic text-[#1BA8E0]">
                                ownership mindset
                            </span>
                            .
                        </h2>
                    </Reveal>
                    <Reveal delay={0.12}>
                        <p className="mt-8 text-base leading-relaxed text-slate-600 sm:text-lg">
                            Value Add Management is a multifamily property management and operations
                            company focused on improving the performance of value-add apartment
                            communities.
                        </p>
                        <p className="mt-5 text-base leading-relaxed text-slate-600 sm:text-lg">
                            We combine disciplined property-level execution with an ownership mindset
                            to increase occupancy, strengthen collections, control expenses, improve
                            property conditions, and grow Net Operating Income.
                        </p>
                        <button
                            data-testid="who-we-are-philosophy-link"
                            onClick={() => scrollToId("philosophy")}
                            className="group mt-8 inline-flex items-center gap-2 text-sm font-semibold text-[#0B1934] transition-colors hover:text-[#1BA8E0]"
                        >
                            Read our philosophy
                            <ArrowRight
                                size={16}
                                className="transition-transform duration-300 group-hover:translate-x-1"
                            />
                        </button>
                    </Reveal>
                </div>
                <div className="lg:col-span-6">
                    <Reveal delay={0.15} className="relative">
                        <div className="absolute -left-4 -top-4 h-full w-full rounded-[1.75rem] border border-[#C5A059]/40" />
                        <div className="relative overflow-hidden rounded-[1.75rem] shadow-xl">
                            <img
                                src="/images/exterior.jpg"
                                alt="Two-story garden-style apartment building exterior at dusk"
                                className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-105"
                            />
                        </div>
                        <div className="absolute -bottom-6 -right-2 rounded-2xl bg-[#0A1224] px-6 py-5 shadow-2xl sm:-right-6">
                            <p className="font-display text-2xl font-extrabold text-[#1BA8E0]">NOI</p>
                            <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-400">
                                The scorecard we manage to
                            </p>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
